// export default ContactUsModalCustomisation  
/* eslint-disable max-len */
/* eslint-disable no-useless-escape */
import React, { useEffect, useRef, useState } from 'react'
import { Modal, Text, TextInput } from '..'
import { IconButton } from '@material-ui/core'
import { colors } from '../../Themes'
import ClearIcon from '@material-ui/icons/Clear'
import { Axios } from '../../Config'
import { SecondaryOutlinedButton3 } from '../Button/Button'
import { SelectInput } from '../Input'
import SucessModal from '../SuccessModal/SuccessModal'
import { SmartTargetModalStyles, selectedStyles } from './SmartTargetModal.styles'

const SELECT_OPTIONS = [
  { value: 'For the business',  label: 'For the business' },
  { value: 'For the locations', label: 'For the locations' },
  { value: 'For practitioners', label: 'For practitioners' },
]

function SmartTargetModal({ isVisible, cancel }) {
  const classes = SmartTargetModalStyles()
  const [value, setValue] = useState('')
  const [dropdownValues, setDropdownValues] = useState('')
  const [isDisabled, setDisabled] = useState(true)
  const [success, setSuccess] = useState(false)
  const [error, setError] = useState()
  const [isLoading, setLoading] = useState(false)

  useEffect(() => {
    if (
      value.length === 0 || dropdownValues === ''
    ) {
      setDisabled(true)
    } else {
      setDisabled(false)
    }
  }, [value, dropdownValues])

  const onSubmit = async (category, description) => {
    setLoading(true)
    try {
      await Axios.post('/prod/contactUs',
        {
          customisationType: category,
          details: `Smart Target: ${description}`
        }
      ).then((response) => console.log(response)
      )
      setSuccess(true)
      setLoading(false)
      setValue('')
      setDropdownValues('')
      setDisabled(true)
    } catch (error) {
      setError(error)
      setLoading(false)
    }
  }
  
  const onCancel = () => {
    setSuccess(false)
    setValue('')
    setDropdownValues('')
    setError()
    setDisabled(true)
    setLoading(false)
    cancel()
    
  }

  const handleChange = (value) => {
    setDropdownValues(value)
  }

  const smartTarget = (
    <div className={classes.ModalWrapper}>
      <div className={classes.subModal}>
        <div className={classes.text}>
          <Text size='h5' color={colors.purple} weight='bold' className={classes.spaceTittle} >Request Smart Targets</Text>
        </div>
        <IconButton
          disableFocusRipple
          centerRipple={true}
          disableRipple={true}
          style={{ backgroundColor: 'transparent' }}
          classes={{ root: classes.iconButtonClose }}
          onClick={() => onCancel()}
        >
          <ClearIcon classes={{ root: classes.iconButtonClose }} />
        </IconButton>
      </div>
      <div className={classes.border} />
      <div className={classes.text2}>
        <Text size='subnote' color={colors.primary} className={classes.spaceText2}>Set the targets that you need for your practice.</Text>
      </div>
      <div className={classes.subText2}>
        <Text size='subnote' color={colors.primary} weight='bold' className={classes.underTitle} >I would like to set targets for:</Text>
      </div>
      <div className={classes.dropwdownWrapper}>
        <SelectInput
          value={dropdownValues}
          selectCostumStyles={selectedStyles}
          label="Requests"
          placeholder="Select target"
          options={SELECT_OPTIONS}
          onChange={(val) => handleChange(val)}
        />
      </div>
      <div className={classes.subText}>
        <Text size='subnote' color={colors.primary} weight='bold' className={classes.underTitle} >I would like to set targets on:</Text>
      </div>
      <div className={classes.inputForm}>
        <TextInput
          name='reason'
          costumizedInputStyles={classes.input}
          label='Describe the metrics and KPIs you would like to set targets on.'
          value={value}
          onChange={(e) => setValue(e.target.value)}
          multiline={true}
          rows={6}
        />
      </div>
      {error &&
          <div className={classes.errorDiv}>
            <Text className={classes.errorText} color={colors.secondary} size='footnote'>{error.response.data.error.message}</Text>
          </div>
      }
      <div className={classes.border2} />
      <div className={classes.buttonsWrapper}>
        <SecondaryOutlinedButton3
          className={classes.cancelButton}
          onClick={onCancel}
        > Cancel
        </SecondaryOutlinedButton3>
        <SecondaryOutlinedButton3
          className={classes.nextButton}
          disabled={isDisabled || isLoading}
          loading={isLoading}
          style={{
            backgroundColor: isDisabled || isLoading ? colors.disabled : colors.primary,
            color: colors.white,
          }}
          onClick={() => onSubmit(dropdownValues.value, value)}
        >
          Request
        </SecondaryOutlinedButton3>
      </div>
    </div>
  )

  
  return (
    <Modal type="noBlur" costumizedPaperStyles={success ? classes.paperCostum2 : classes.paperCostum} opened={isVisible}>
      {success ? <SucessModal isSmart onCancel={onCancel} /> : 
        smartTarget}

      
    </Modal>
  )
}



export default SmartTargetModal

